import { render } from "./ConfirmModal.vue?vue&type=template&id=0a3dcf2f&scoped=true"
import script from "./ConfirmModal.vue?vue&type=script&lang=js"
export * from "./ConfirmModal.vue?vue&type=script&lang=js"

import "./ConfirmModal.vue?vue&type=style&index=0&id=0a3dcf2f&lang=less&scoped=true"

import exportComponent from "E:\\qq\\前端(1)\\前端\\后台vue\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3dcf2f"]])

export default __exports__